import { Link } from '@remix-run/react'
import { useState } from 'react'
import ContactModal from '#app/components/contact-modal'
import PlentyBody from '#app/components/typography/plenty-body'
import PlentyHeading from '#app/components/typography/plenty-heading.tsx'
import { Button } from '#app/components/ui/button'

export default function ByeInformation() {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const toggleModal = () => setIsModalOpen(!isModalOpen)
	return (
		<div className="flex flex-col items-center justify-center gap-10 px-4 py-4 md:h-[calc(100vh-150px)] md:px-[var(--plenty-padding)]">
			<div className="flex flex-col items-center justify-center gap-4 text-center">
			
				<PlentyHeading as="h7">Plenty& (Plentyand.dk) lukker.</PlentyHeading>
				<PlentyBody size={'md'} className="flex">
					Hos Plenty& har vi forsøgt at skabe en platform, der gør det nemt for
					dig at handle lokalt. Desværre har vi ikke kunne lykkes, som vi havde
					håbet, derfor har vi valgt at lukke for platformen.
				</PlentyBody>
				<PlentyBody size={'md'} className="flex">
					Tak for alle jer, der har handlet hos os og besøgt platformen. Og ikke
					mindst tak til alle vores butikker, der har været en del af projektet.
				</PlentyBody>
				<PlentyBody size={'md'} className="">
					Har du spørgsmål vedrørende din ordre kan du skrive til:
					<span className="pl-1 underline">Support@plentyand.dk</span>
				</PlentyBody>
				<PlentyBody size={'md'} className="flex flex-wrap text-center">
					Ønsker du at oprette en retur kan du gøre det her nedenfor her.
				</PlentyBody>
			</div>
			<div className="mx-auto flex flex-col gap-4 md:flex-row">
				<Link to="/returns">
					<Button size={'primary'} variant={'primary'}>
						Returnering
					</Button>
				</Link>
				<ContactModal isOpen={isModalOpen} onClose={toggleModal} />
			</div>
		</div>
	)
}
